<div class="center-absolute" [ngClass]="{ background: !transparentBackground }" *ngIf="state.show" @appearDisappear>
  <div class="flex flex-col justify-center items-center w-full relative text-gray-600">
    <y42-logo-loader *ngIf="!state.error" [widthInPixel]="70"> </y42-logo-loader>

    <img *ngIf="state.error" height="70" src="assets/images/general/error.svg" alt="Error" />

    <span class="mb-3 mt-2 text-center fs-1 status-text max-w-[600px] pl-2 pr-2" [class.has-error]="state.error">{{
      state.statusDescription
    }}</span>

    <ng-container *ngIf="state.error">
      <div class="git-reset-button">
        <y42-git-hard-reset-button></y42-git-hard-reset-button>
      </div>
    </ng-container>
  </div>
</div>
